import './place-info.scss';
import ModalItem from '../../common/ModalItem/ModalItem';
import React, { useContext } from 'react';
import { Route, Switch, useParams } from 'react-router';
import { connect } from 'react-redux';
import { Container, Hidden } from '@material-ui/core';
import 'moment/locale/ru';
import 'moment-timezone';
import { useTranslation } from 'react-i18next';
import TaskInfo from '../TaskInfo/TaskInfo';
import TasksGridItem from '../TasksGridItem/TasksGridItem';
import Grid from '@material-ui/core/Grid';
import IsMobileContext from '../../../common/IsMobileContext';
import { completedRoutes } from '../../../common/constants';
import { toNumber, isArray } from 'lodash';
import WorkTimes from './WorkTimes';
import UndefinedPlace from './UndefinedPlace';

const ContentSwitch = (props) => {
  const { desktopOption, content } = props;

  return (
    <Switch>
      <Route path={`${completedRoutes.taskInfoWithoutId}/:taskId`}>
        <TaskInfo />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function PlaceInfo(props) {
  const { t } = useTranslation();
  const params = useParams();
  const placeId = toNumber(params.placeId);
  const [isDescriptionExpand, setExpandedDescription] = React.useState(false);
  const isMobileDesign = useContext(IsMobileContext);

  const handleExpandDescription = () => {
    setExpandedDescription(!isDescriptionExpand);
  };

  const placeData = placeId && props.userPlacesById[placeId];
  if ((placeData === undefined || props.regionsBySysname.length === 0)) {
    if (props.isUserPlacesFetched && props.isRegionsFetched) {
      return <UndefinedPlace />
    }
    return null;
  }

  const activePlaceTasks = tasksByPlaceId(props.tasksById, props.tasksAllIds, placeData['likengo_id']);

  const workTimes = placeData.worktimes;
  const isWorkTimesDefined = !isArray(workTimes) && workTimes;

  // const shortDescription = placeData.description.split('\n').slice(0, 1).join('\n');
  // const restDescription = placeData.description.split('\n').slice(2, -1).join('\n');

  const backgroundStyle = !placeData.cover ? {} : {
    background: `url(${placeData.cover}) no-repeat center`,
    backgroundSize: 'cover',

  };

  const content = (
    <div className="company-info-container">
      <div className="img-cnt" style={backgroundStyle}>
        {/*<img src={placeData.cover} alt="place cover" className="img" />*/}
        <div className="type-name">
          <span className="name">{placeData.name}</span>
          <span className="type">{placeData.typename}</span>
        </div>
        <div className="blackout" />
      </div>
      <Container>
        <div className="address-cnt">
          <span className="address">{placeData.address}</span>
        </div>

        {isWorkTimesDefined && <WorkTimes placeData={placeData}
                                          workTimes={workTimes}
                                          regionsBySysname={props.regionsBySysname}
        />}


        {/*<div className="description-cnt">*/}
        {/*  <span dangerouslySetInnerHTML={{ __html: shortDescription }} />*/}

        {/*  {restDescription && <>*/}
        {/*  <span onClick={handleExpandDescription}*/}
        {/*        className="description">*/}
        {/*        {isDescriptionExpand ? t('placeInfo.closeDesc') : t('placeInfo.openDesc')}*/}
        {/*  </span>*/}
        {/*    <Collapse in={isDescriptionExpand} timeout="auto" unmountOnExit>*/}
        {/*      <span dangerouslySetInnerHTML={{ __html: restDescription }} />*/}
        {/*    </Collapse>*/}
        {/*  </>}*/}

        {/*</div>*/}

        <div className={`description-cnt-2 ${isDescriptionExpand ? 'expanded' : ''}`}>
          <div dangerouslySetInnerHTML={{ __html: placeData.description }}/>
          <div className="phone-cnt">
            <a href={`tel:${placeData.phone}`} className="phone">{placeData.phone}</a>
          </div>
        </div>
        <div onClick={handleExpandDescription} className="description">
          <div>{isDescriptionExpand ? t('placeInfo.closeDesc') : t('placeInfo.openDesc')}</div>
        </div>

        <span className="active-tasks">{t('placeInfo.activeTasks')}</span>
        {activePlaceTasks.length === 0 && <span className="no-tasks">{t('placeInfo.noTasks')}</span>}
      </Container>
      {activePlaceTasks.length !== 0 && (
        <Grid container spacing={1} className="tasks-grid-container">
          {activePlaceTasks.map((i) => {
            return <TasksGridItem task={i} md={6} key={`task-${i.id}`} />;
          })}
        </Grid>
      )}
    </div>
  );

  return (
    <ModalItem whiteArrowBack goBackAbsolutePosition>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} />
      </>
    </ModalItem>
  );
}

const tasksByPlaceId = (tasksById, tasksAllIds, id) => {
  const tasks = tasksAllIds.map((i) => tasksById[i]);
  return tasks.filter((task) => {
    const { placeId, state } = task;
    return placeId === id && state === 'active';
  })
};

const mapStateToProps = state => ({
  tasksById: state.tasks.data.byId,
  tasksAllIds: state.tasks.data.allIds,
  regionsBySysname: state.regions.data,
  userPlacesById: state.places.userPlaces.byId,
  isUserPlacesFetched: state.places.userPlacesFetchingState === 'success',
  isRegionsFetched: state.regions.fetchingState === 'success',
});

export default connect(mapStateToProps)(PlaceInfo);
